export default __webpack_public_path__ + "static/laurier-0a20f0a52595031f05f987f2c4ec4cb4.svg";